module.exports = __webpack_public_path__ + "img/ztb.476f54b8.png";